import { render, staticRenderFns } from "./InteractiveList.vue?vue&type=template&id=588b4027&scoped=true"
import script from "./InteractiveList.vue?vue&type=script&lang=js"
export * from "./InteractiveList.vue?vue&type=script&lang=js"
import style0 from "./InteractiveList.vue?vue&type=style&index=0&id=588b4027&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b4027",
  null
  
)

export default component.exports